import { gql } from '@apollo/client';

const ALL_TOURNAMENT_CATEGORIES_WITH_PARTNERS = gql`
  query tournamentCategoriesWithPartnersCount($filter: ListCategorySettingInput) {
    tournamentCategoriesWithPartnersCount(filter: $filter)
  }
`;

export default ALL_TOURNAMENT_CATEGORIES_WITH_PARTNERS;
